const playVideoButtons = document.querySelectorAll('.play-video');
if (playVideoButtons) {
    playVideoButtons.forEach(button => {
        const video = button.parentNode.querySelector('.play-video-dialog');
        if (!video) return;

        document.body.appendChild(video);

        button.addEventListener('click', () => {
            video.showDialog();
        });
    });
}

$(function() {
    setTimeout(function() {
        $(".hidden-scroll-element").scroll(function() {
            $(".comparison-chart-container").scrollLeft($(".hidden-scroll-element").scrollLeft());
        }).scroll();

        $(".comparison-chart-container").scroll(function() {
            $(".hidden-scroll-element").scrollLeft($(".comparison-chart-container").scrollLeft());
        }).scroll();
    }, 500);

    let jawkuSlideshow = $('.jawku-slideshow');
    if (jawkuSlideshow) {
        $('.jawku-slideshow').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            customPaging : function(slider, i) {
                return '<i></i>';
            }
        });
    }

    // Partner Logos with Quotes
    let partnerLogos = $('.partner-logo-section .inner-container .partner-logo');

    if (partnerLogos.length <= 0) {
        $('.partner-logo-section').hide();
    } else {
        let desktopQuote = $('.partner-quote.desktop');
        let logoSlider = $('.partner-logo-section .logo-slider');
        let windowWidth = window.innerWidth;
        let firstQuoteElement = $('.partner-logo-section .inner-container .partner-logo:first-of-type');

        let args = {
            autoplay: true,
            autoplaySpeed: 2000,
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            initialSlide: 0,
            customPaging: function () {
                return '<i class="fas fa-circle"></i>';
            }
        };

        $('.partner-quote.desktop').attr('data-logo-index', firstQuoteElement.data('logo-index'));
        $('.partner-quote.desktop span').html(firstQuoteElement.data('quote'));

        logoSlider.on('afterChange', function (event, slick, currentSlide) {
            let currentSlideIndex = currentSlide + 1;
            $('.partner-quote.desktop').attr('data-logo-index', currentSlideIndex);
            desktopQuote.find('span').html($('.partner-logo[data-logo-index="' + currentSlideIndex + '"]').attr('data-quote'));
        });

        if (windowWidth > 798) {
            args.slidesToShow = 4;
            logoSlider.slick(args);
        } else {
            args.slidesToShow = 1;
            logoSlider.slick(args);
        }

        $(window).resize(function () {
            let windowWidth = window.innerWidth;
            //console.log(windowWidth);

            if (windowWidth > 798) {
                if (logoSlider.hasClass('slick-initialized')) {
                    logoSlider.slick('unslick');
                }
                args.slidesToShow = 4;

                logoSlider.slick(args);

                logoSlider.on('afterChange', function (event, slick, currentSlide) {
                    let currentSlideIndex = currentSlide + 1;
                    $('.partner-quote.desktop').attr('data-logo-index', currentSlideIndex);
                    desktopQuote.find('span').html($('.partner-logo[data-logo-index="' + currentSlideIndex + '"]').attr('data-quote'));
                });
            } else {
                if (logoSlider.hasClass('slick-initialized')) {
                    logoSlider.slick('unslick');
                }
                args.slidesToShow = 1;
                logoSlider.on('afterChange', function (event, slick, currentSlide) {
                    let currentSlideIndex = currentSlide + 1;
                    $('.partner-quote.desktop').attr('data-logo-index', currentSlideIndex);
                });

                logoSlider.slick(args);
            }
        });
    }

    // Partners with a Profession
    if ($('.partners-text .inner-text').length <= 0) {
        $('.partner-logo-section').hide();
    } else {
        let partnersSlide = $('.partners-slider .inner-slider');
        let arrowLeft = $('.partners-controls .arrow-left');
        let arrowRight = $('.partners-controls .arrow-right');

        arrowLeft.click(function () {
            partnersSlide.slick('slickPrev');
        });

        arrowRight.click(function () {
            partnersSlide.slick('slickNext');
        });

        partnersSlide.on('afterChange', function (slick, activeSlide) {
            let currentSlideElement = $('.inner-slider .slick-active');

            let currentPartnerName = currentSlideElement.attr('data-partner-name');
            let currentPartnerProfession = currentSlideElement.attr('data-partner-profession');
            let currentPartnerQuote = currentSlideElement.attr('data-partner-quote');
            let currentButtonLink = currentSlideElement.attr('data-button-link');
            let actionButton = $('.partners-text .inner-text .action_button');

            $('.partners-text .inner-text .partner-name').html(currentPartnerName);
            $('.partners-text .inner-text .partner-profession').html(currentPartnerProfession);
            $('.partners-text .inner-text .partner-quote').html(currentPartnerQuote);

            if (currentButtonLink) {
                actionButton.attr('href', currentButtonLink);
                actionButton.show();
            } else {
                actionButton.hide();
            }
        });

        partnersSlide.slick({
            accessibility: true,
            focusOnChange: true,
            draggable: false,
            dots: false,
            arrows: false,
            infinite: true,
            initialSlide: 0,
            touchThreshold: 10,
            variableWidth: true,
            mobileFirst: true
        });

        $('body').on("click", ".inner-slide", function(e) {
            let clickedSlide = $(e.currentTarget);
            let clickedSlideIndex = clickedSlide.data("slick-index");

            partnersSlide.slick('slickGoTo', clickedSlideIndex, false);
        });
    }
});
